import { ArticleShortcut } from '../../assets/icons/Icons';
import { Tab, Tabs } from '@mui/material';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import RolesIndex from './Roles/RolesIndex';
import useAdmin from './hooks/useAdmin';
import UsersIndex from './Users/UsersIndex';

function RenderComponent({ value }: { value: number }) {
    switch (value) {
        case 0:
            return <UsersIndex />;
        case 1:
            return <RolesIndex />;
        default:
            return <></>;
    }
}

function Administracion() {
    const { tabValue, handleChangeTab } = useAdmin();

    return (
        <>
            <Tabs
                onChange={handleChangeTab}
                value={tabValue > 0 ? tabValue : 0}
                className="admin-tabs"
            >
                <Tab icon={<CreateNewFolderOutlinedIcon />} iconPosition="start" label="Usuarios" />
                <Tab
                    icon={<ArticleShortcut color={tabValue !== 0 ? 'var(--primary)' : ''} />}
                    iconPosition="start"
                    label="Roles"
                />
            </Tabs>

            <div className="admin-section-wrapper">
                <RenderComponent value={tabValue} />
            </div>
        </>
    );
}

export default Administracion;
